"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_service_1 = require("./api-service");
var CmsService = /** @class */ (function (_super) {
    __extends(CmsService, _super);
    function CmsService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'cms';
        return _this;
    }
    CmsService.prototype.template = function (code) {
        return this.getRequest(this.url('template', 'view'), code ? { headers: { 'x-template-code': code } } : {});
    };
    CmsService.prototype.templates = function (params) {
        return this.getCollectionRequest(this.url('templates'), {
            params: params,
        });
    };
    CmsService.prototype.getTemplate = function (code) {
        return this.getRequest(this.url('templates', code));
    };
    CmsService.prototype.createTemplate = function (template) {
        return this.postRequest(this.url('templates'), template);
    };
    CmsService.prototype.newTemplate = function (template) {
        return this.postRequest(this.url('templates', 'new'), template);
    };
    CmsService.prototype.importTemplate = function (data) {
        return this.postRequest(this.url('templates', 'import'), data, {
            headers: {
                'Content-Type': 'multipart/form-type',
            },
        });
    };
    CmsService.prototype.exportTemplate = function (code, data) {
        return this.postRequest(this.url('templates', code, 'export'), data);
    };
    CmsService.prototype.deleteTemplate = function (id) {
        return this.deleteRequest(this.url('templates', id));
    };
    CmsService.prototype.updateTemplate = function (id, data) {
        return this.patchRequest(this.url('templates', id), data);
    };
    CmsService.prototype.replaceTemplate = function (id, data) {
        return this.putRequest(this.url('templates', id), data);
    };
    CmsService.prototype.installPreset = function (templateId, presetId) {
        return this.postRequest(this.url('templates', templateId, 'install', presetId));
    };
    // CMS Media Manager
    CmsService.prototype.medias = function (params) {
        return this.getCollectionRequest(this.url('media'), { params: params });
    };
    CmsService.prototype.getMedia = function (id) {
        return this.getRequest(this.url('media', id));
    };
    /** Requires transformation from object compatible with CreateMedia interface to FormData **/
    CmsService.prototype.createMedia = function (data) {
        return this.postRequest(this.url('media'), data);
    };
    /** Requires transformation from object compatible with UpdateMedia interface to FormData **/
    CmsService.prototype.updateMedia = function (id, data) {
        return this.postRequest(this.url('media', id), data);
    };
    CmsService.prototype.deleteMedia = function (id) {
        return this.deleteRequest(this.url('media', id));
    };
    CmsService.prototype.pages = function (code, params) {
        return this.getCollectionRequest(this.url('pages'), {
            params: params,
            headers: { 'x-template-code': code },
        });
    };
    CmsService.prototype.getPage = function (code, id) {
        return this.getRequest(this.url('pages', id), { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.createPage = function (code, page) {
        return this.postRequest(this.url('pages'), page, { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.updatePage = function (code, id, data) {
        return this.putRequest(this.url('pages', id), data, { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.deletePage = function (code, id) {
        return this.deleteRequest(this.url('pages', id), { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.blocks = function (code, params) {
        return this.getCollectionRequest(this.url('blocks'), {
            params: params,
            headers: { 'x-template-code': code },
        });
    };
    CmsService.prototype.getBlock = function (code, id) {
        return this.getRequest(this.url('blocks', id), { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.updateBlock = function (code, id, data) {
        return this.putRequest(this.url('blocks', id), data, { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.parseSetting = function (code) {
        return this.getRequest(this.url('settings', code, 'parse'));
    };
    CmsService.prototype.settings = function (code, params) {
        return this.getCollectionRequest(this.url('settings'), {
            params: params,
            headers: { 'x-template-code': code },
        });
    };
    CmsService.prototype.getSetting = function (code, id) {
        return this.getRequest(this.url('settings', id), { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.updateSetting = function (code, id, data) {
        return this.putRequest(this.url('settings', id), data, { headers: { 'x-template-code': code } });
    };
    CmsService.prototype.presets = function (params) {
        return this.getCollectionRequest(this.url('presets'), {
            params: params,
            headers: { 'x-store-id': null },
        });
    };
    CmsService.prototype.getPreset = function (id) {
        return this.getRequest(this.url("presets/".concat(id)), { headers: { 'x-store-id': null } });
    };
    CmsService.prototype.createPreset = function (page) {
        return this.postRequest(this.url('presets'), page, { headers: { 'x-store-id': null } });
    };
    CmsService.prototype.updatePreset = function (id, data) {
        return this.putRequest(this.url('presets', id), data, { headers: { 'x-store-id': null } });
    };
    CmsService.prototype.deletePreset = function (id) {
        return this.deleteRequest(this.url('presets', id), { headers: { 'x-store-id': null } });
    };
    CmsService.prototype.importPreset = function (data) {
        var headers = {
            'x-store-id': null,
            'Content-Type': 'multipart/form-type',
        };
        return this.postRequest(this.url('presets', 'import'), data, { headers: headers });
    };
    CmsService.prototype.exportPreset = function (code, data) {
        return this.postRequest(this.url('presets', code, 'export'), data, {
            headers: { 'x-store-id': null },
        });
    };
    CmsService.prototype.presetPages = function (code, params) {
        return this.getCollectionRequest(this.url('presets', 'pages'), {
            params: params,
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.getPresetPage = function (code, id) {
        return this.getRequest(this.url('presets', 'pages', id), {
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.createPresetPage = function (code, page) {
        return this.postRequest(this.url('presets', 'pages'), page, {
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.updatePresetPage = function (code, id, data) {
        return this.putRequest(this.url('presets', 'pages', id), data, {
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.deletePresetPage = function (code, id) {
        return this.deleteRequest(this.url('presets', 'pages', id), {
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.presetBlocks = function (code, params) {
        return this.getCollectionRequest(this.url('presets', 'blocks'), {
            params: params,
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.getPresetBlock = function (code, id) {
        return this.getRequest(this.url('presets', 'blocks', id), {
            headers: {
                'x-store-id': null,
                'x-preset-code': code,
            },
        });
    };
    CmsService.prototype.updatePresetBlock = function (code, id, data) {
        return this.putRequest(this.url('presets', 'blocks', id), data, {
            headers: { 'x-store-id': null, 'x-preset-code': code },
        });
    };
    CmsService.prototype.deletePresetBlock = function (code, id) {
        return this.deleteRequest(this.url('presets', 'blocks', id), {
            headers: { 'x-store-id': null, 'x-preset-code': code },
        });
    };
    // Preset Settings
    CmsService.prototype.presetSettings = function (code, params) {
        return this.getCollectionRequest(this.url('presets', 'settings'), {
            params: params,
            headers: { 'x-store-id': null, 'x-preset-code': code },
        });
    };
    CmsService.prototype.getPresetSetting = function (code, id) {
        return this.getRequest(this.url('presets', 'settings', id), {
            headers: { 'x-store-id': null, 'x-preset-code': code },
        });
    };
    CmsService.prototype.createPresetSetting = function (code, data) {
        return this.postRequest(this.url('presets', 'settings'), data, {
            headers: { 'x-store-id': null, 'x-preset-code': code },
        });
    };
    CmsService.prototype.updatePresetSetting = function (code, id, data) {
        return this.putRequest(this.url('presets', 'settings', id), data, {
            headers: { 'x-store-id': null, 'x-preset-code': code },
        });
    };
    return CmsService;
}(api_service_1.ApiService));
exports.default = CmsService;
//# sourceMappingURL=cms-service.js.map